import { useLocation } from 'react-router-dom';

import { AppRoutes } from 'constants/routes-paths.constants';
import { ComplectForm } from 'page-components/complects/ComplectForm';
import { PageLayout } from 'page-components/page-layout/PageLayout';

export const Complect = () => {
  const { pathname } = useLocation();

  const editTitle = pathname === AppRoutes.complectCreate ? 'create_complect' : 'edit_complect';
  const titleText = pathname.includes('view') ? 'view_complect' : editTitle;

  return (
    <PageLayout title={titleText} wrapperClassName='flex flex-col gap-4'>
      <ComplectForm />
    </PageLayout>
  );
};
